import { Product, ProductType } from '@/store/modules/product';
import { BaseSectionCreator } from './baseSectionCreator';
import { ChestFurnitureSectionCreator } from './chestFurnitureSectionCreator';
import { BedSectionCreator } from './bedSectionCreator';
import { TableSectionCreator } from './tableSectionCreator';
import { CoffeeTableSectionCreator } from './coffeeTableSectionCreator';
import { BedsideTableSectionCreator } from './bedsideTableSectionCreator';
import { NullSectionCreator } from './nullSectionCreator';
import { DeskSectionCreator } from './deskSectionCreator';
import { CoffeeTableRectangleSectionCreator } from './coffeeTableRectangleSectionCreator';
import { DressingSectionCreator } from './dressingSectionCreator';

export class SectionCreatorFactory {

    private chestFurnitureSectionCreator: ChestFurnitureSectionCreator | null = null;
    private bedSectionCreator: BedSectionCreator | null = null;
    private tableSectionCreator: TableSectionCreator | null = null;
    private coffeeTableSectionCreator: CoffeeTableSectionCreator | null = null;
    private bedsideTableSectionCreator: BedsideTableSectionCreator | null = null;
    private deskSectionCreator: DeskSectionCreator | null = null;
    private coffeeTableRectangleSectionCreator: CoffeeTableRectangleSectionCreator | null = null;
    private dressingSectionCreator: DressingSectionCreator | null = null;
    private nullSectionCreator: NullSectionCreator | null = null;

    constructor(
        private scenePreview: any,
    ) { }

    public get(product: Product): BaseSectionCreator {
        if (product.type === ProductType.CHEST_FURNITURE) {
            return this.getChestFurnitureSectionCreator();
        }
        if (product.type === ProductType.BED) {
            return this.getBedSectionCreator();
        }
        if (product.type === ProductType.TABLE) {
            return this.getTableSectionCreator();
        }
        if (product.type === ProductType.COFFEE_TABLE) {
            return this.getCoffeeTableSectionCreator();
        }
        if (product.type === ProductType.BEDSIDE_TABLE) {
            return this.getBedsidetableSectionCreator();
        }
        if (product.type === ProductType.DESK) {
            return this.getDeskSectionCreator();
        }
        if (product.type === ProductType.COFFEE_TABLE_RECTANGLE) {
            return this.getCoffeeTableRectangleSectionCreator();
        }
        if (product.type === ProductType.DRESSING) {
            return this.getDressingSectionCreator();
        }
        return this.getNullSectionCreator();
    }

    private getChestFurnitureSectionCreator(): BaseSectionCreator {
        if (!this.chestFurnitureSectionCreator) {
            this.chestFurnitureSectionCreator = new ChestFurnitureSectionCreator(this.scenePreview);
        }
        return this.chestFurnitureSectionCreator;
    }

    private getBedSectionCreator(): BaseSectionCreator {
        if (!this.bedSectionCreator) {
            this.bedSectionCreator = new BedSectionCreator(this.scenePreview);
        }
        return this.bedSectionCreator;
    }

    private getTableSectionCreator(): BaseSectionCreator {
        if (!this.tableSectionCreator) {
            this.tableSectionCreator = new TableSectionCreator(this.scenePreview);
        }
        return this.tableSectionCreator;
    }

    private getCoffeeTableSectionCreator(): BaseSectionCreator {
        if (!this.coffeeTableSectionCreator) {
            this.coffeeTableSectionCreator = new CoffeeTableSectionCreator(this.scenePreview);
        }
        return this.coffeeTableSectionCreator;
    }

    private getBedsidetableSectionCreator(): BaseSectionCreator {
        if (!this.bedsideTableSectionCreator) {
            this.bedsideTableSectionCreator = new BedsideTableSectionCreator(this.scenePreview);
        }
        return this.bedsideTableSectionCreator;
    }

    private getDeskSectionCreator(): BaseSectionCreator {
        if (!this.deskSectionCreator) {
            this.deskSectionCreator = new DeskSectionCreator(this.scenePreview);
        }
        return this.deskSectionCreator;
    }

    private getCoffeeTableRectangleSectionCreator(): CoffeeTableRectangleSectionCreator {
        if (!this.coffeeTableRectangleSectionCreator) {
            this.coffeeTableRectangleSectionCreator = new CoffeeTableRectangleSectionCreator(this.scenePreview);
        }
        return this.coffeeTableRectangleSectionCreator;
    }

    private getDressingSectionCreator(): DressingSectionCreator {
        if (!this.dressingSectionCreator) {
            this.dressingSectionCreator = new DressingSectionCreator(this.scenePreview);
        }
        return this.dressingSectionCreator;
    }

    private getNullSectionCreator(): BaseSectionCreator {
        if (!this.nullSectionCreator) {
            this.nullSectionCreator = new NullSectionCreator(this.scenePreview);
        }
        return this.nullSectionCreator;
    }
}
